import { useSelector } from 'react-redux';

const Decision = ({ reverse, selector, children }) => {
  const selectorValue = useSelector(selector);

  if (!!selectorValue === !reverse) {
    return children;
  }
  return null;
};

export default Decision;
